@switch (config().variant) {
  @case ("range") {
    <div class="relative overflow-hidden rounded-(--goalcard-border-radius) h-70">
      <!-- Progress wave -->
      <img
        src="assets/images/goal-card-progress-wave.svg"
        alt=""
        class="absolute top-8 left-0 w-full h-44"
      />

      <!-- Vertical dashed lines -->
      <div class="absolute left-12 top-5 h-52 border-l border-dashed border-(--goalcard-range-line-color)"></div>
      <div class="absolute right-11 top-5 h-52 border-l border-dashed border-(--goalcard-range-line-color)"></div>

      <!-- Start value (bottom left) -->
      <div class="absolute left-5 bottom-3">
        <app-dynamic
          componentName="DynamicText"
          [props]="{
            config: {
              text: config().startValue,
              size: 'base',
              fontWeight: 'semibold',
              color: 'var(--goalcard-range-start-color)',
            },
          }"
        />
      </div>

      <!-- End value (bottom right) -->
      <div class="absolute right-5 bottom-3">
        <app-dynamic
          componentName="DynamicText"
          [props]="{
            config: {
              text: config().endValue,
              size: 'base',
              fontWeight: 'semibold',
              color: 'var(--goalcard-range-end-color)',
            },
          }"
        />
      </div>
    </div>
  }
  @default {
    <div
      [ngStyle]="backgroundStyle()"
      class="relative overflow-hidden rounded-(--goalcard-border-radius) p-(--goalcard-padding) font-(family-name:--goalcard-font-family) min-h-35"
    >
      <!-- Decorative wave -->
      <img
        src="assets/images/goal-card-wave.svg"
        alt=""
        class="absolute top-2 left-1/2 -translate-x-1/2 h-[80%] w-full max-w-100 pointer-events-none"
      />

      <!-- Content -->
      <div class="relative flex flex-col items-start gap-(--goalcard-gap)">
        <!-- Chip label -->
        @if (config().label) {
          <app-dynamic
            componentName="Chip"
            [props]="{
              config: {
                text: config().label,
                variant: 'subtle',
              },
            }"
          />
        }

        <!-- Value + Unit -->
        <div class="flex items-center gap-2">
          <app-dynamic
            componentName="DynamicText"
            [props]="{
              config: {
                text: config().value,
                size: '4xl',
                fontWeight: 'semibold',
                color: 'var(--goalcard-value-color)',
              },
            }"
          />
          <app-dynamic
            componentName="DynamicText"
            [props]="{
              config: {
                text: config().text,
                size: 'base',
                fontWeight: 'semibold',
                color: 'var(--goalcard-text-color)',
              },
            }"
          />
        </div>
      </div>
    </div>
  }
}
